module.exports = flarum.core.compat['flags/components/FlagPostModal'];